import React, {FC, useEffect, useState} from 'react';
import './service-link-img.scss';
import ArrowIcon from './arrow.svg';
import {getImgUrl} from "./actions";

const ServiceLinkImg: FC = (props: any) => {
    const [st, setSt] = useState({});

    useEffect(() => {
        if (props.img) {
            getImgUrl(props.img).then(
                value => {
                    if (value.data) {
                        setSt({
                            background: `url(${value.data}) 100% 100% / cover no-repeat`,
                        });
                    }
                }
            );
        }
    }, []);

    const getUrl = () => {
        if (props.isRedirect) {
            return props.redirectUrl;
        }

        return props.url;
    };

    return (
        <a
            className="service-link-img"
            style={st}
            href={getUrl()}
        >
            <span
                style={{
                    maxWidth: +props.maxWidth,
                }}
            >
                {props.name}
            </span>
            <ArrowIcon />
        </a>
    );
};

export default ServiceLinkImg;
